import { call, put, select, takeEvery } from "redux-saga/effects";

import { LogoutActionCreator } from "../inheritFromWeeb-ui-v2/areas/auth/state/actions";
import { AUTH_USER, INIT_VISITOR_ID, UNAUTH_USER } from "../../actions/types";
import { buildLoggerTags, pushGtm } from "../../../components/utils/util";
import localMediaStorageOld from "../../../lib/localRecording";
import localMediaRecording from "../../../lib/localRecordingNew";
import type { RootState } from "../rootReducer";

function* updateLoggerTags() {
  const state: RootState = yield select();

  const loggerTags = buildLoggerTags(state);

  localMediaRecording.ctx.setLoggerTags(loggerTags);
  localMediaStorageOld.ctx.setLoggerTags(loggerTags);
}

function* signoutUser() {
  localStorage.removeItem("token");
  localStorage.removeItem("superToken");
  localStorage.removeItem("is2FACompleted");
  localStorage.removeItem("ts_user_email");
  pushGtm({
    event: "logout",
    user_id: null,
    user_email: null,
    user_full_name: null,
    organization_id: null,
    organization_name: null,
  });
  yield put({ type: UNAUTH_USER });
}

function* updateLoggerTagsOnAuthChanges() {
  yield takeEvery([AUTH_USER, UNAUTH_USER, INIT_VISITOR_ID], updateLoggerTags);
  yield takeEvery(LogoutActionCreator, signoutUser);
}

export function* authSagas() {
  yield call(updateLoggerTagsOnAuthChanges);
}
